import React, { useState } from "react";
import "../componentCss/webform.css";
import "../componentCss/sidebar.css";
import "react-toastify/dist/ReactToastify.css";
import DataTable from 'react-data-table-component';
import config from "../../config/config";
import { Modal, Button, Form } from 'react-bootstrap';
const moment = require('moment');

const PrescriptionList = ({ show, medPassDrugAssignedList, onClose }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);


  const handlePageChange = (page) => {
    setCurrentPage(page - 1);
  };

  const handlePageClick = (row) => {
    window.location.href = `${config.baseUrl}administrative-page/${row.id}/${row.mrnNumber}`;
  }

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };
  const columns = [
    {
      name: '#',
      cell: (row, index) => index + 1 + currentPage * rowsPerPage,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Administrative Page',
      cell: row => (
        <button
          onClick={() => handlePageClick(row)}
        >
          <span>Action</span>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Physician Name',
      selector: row => row.physicianname,
      width: "17%"
    },
    {
      name: 'Drug Name',
      selector: row => row.drugName,
      sortable: true,
      width: "17%"
    },
    {
      name: 'Drug Code',
      selector: row => row.drugCode,
      width: "17%"
    },
    {
      name: 'Rx Start/Cut Datetime',
      selector: row => (
        <>
          {moment(row.rxStartDate).format("YYYY-MM-DD")} {row.rxStartTime} - {moment(row.rxCutDate).format("YYYY-MM-DD")} {row.rxCutTime}
        </>
      ),
      width: "35%"
    },
    {
      name: 'Dosage Type',
      selector: row => row.dosagetype,
      width: "15%"
    },
    {
      name: 'Dosage Quantity',
      selector: row => row.dosagequantity,
      width: "15%"
    },
    {
      name: 'Units',
      selector: row => row.units,
      width: "10%"
    },
    {
      name: 'Status',
      selector: row => (
        <span className={row.status == 1 ? "text-success fw-bold" : "text-danger fw-bold"}>
          {row.status == 1 ? "Running" : "Stopped"}
        </span>
      )
    }
  ];

  
  return (

      <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Notification Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {medPassDrugAssignedList?.length > 0 ?
        <div>
          <DataTable
            columns={columns}
            data={medPassDrugAssignedList}
            pagination
            paginationPerPage={rowsPerPage}
            paginationRowsPerPageOptions={[10, 15, 25, 50, 100]}
            paginationComponentOptions={{
              rowsPerPageText: 'Row per page:',
              rangeSeparatorText: 'out of',
            }}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
          />
        </div>
        :
        <div style={{ textAlign: 'center' }}>
          No Data Found
        </div>
      }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );

};

export default PrescriptionList;